import { Footer } from './Footer';

export const ComponentStrings = {
  ...Footer,
};
